import { useMutation } from "@tanstack/react-query";
import { deleteExceptionDay } from "PFCore/services/booking_config";
import { MutationOptions } from "PFTypes/request_options";

type DeleteExceptionDayData = {
  exceptionDayId: number;
  calendarId: number;
};

type UseDeleteExceptionDay = {
  options?: MutationOptions<DeleteExceptionDayData>;
};

export const useDeleteExceptionDay = ({ options }: UseDeleteExceptionDay) =>
  useMutation({
    mutationFn: ({ calendarId, exceptionDayId }: DeleteExceptionDayData) =>
      deleteExceptionDay(calendarId, exceptionDayId),
    ...options
  });
